import React from 'react';
import { useAudioPlayer } from '../../hooks/useAudioPlayer';
import Icon from '../AppIcon';

/**
 * FloatingPlayButton — shown when audio is loaded, drawer is closed,
 * and audio has been activated (playing or paused after play).
 * Position: fixed bottom-center, above mobile nav.
 */
export default function FloatingPlayButton() {
  const { isLoaded, isPlaying, isOpen, currentTime, play, pause } = useAudioPlayer();

  // Show only when: loaded, drawer closed, and audio has been started (currentTime > 0 or isPlaying)
  const hasBeenActivated = isLoaded && (isPlaying || currentTime > 0);
  if (!hasBeenActivated || isOpen) return null;

  return (
    <button
      onClick={isPlaying ? pause : play}
      aria-label={isPlaying ? 'Pause audio' : 'Play audio'}
      className="fixed z-30 flex items-center justify-center rounded-full shadow-xl transition-all duration-200 active:scale-95"
      style={{
        width: 64,
        height: 64,
        bottom: 80,        // above mobile nav on mobile
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#F59E0B',
        opacity: 0.5,
      }}
      onMouseEnter={e => { e.currentTarget.style.opacity = '0.85'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '0.5'; }}
      onTouchStart={e => { e.currentTarget.style.opacity = '0.85'; }}
      onTouchEnd={e => { e.currentTarget.style.opacity = '0.5'; }}
    >
      <Icon name={isPlaying ? 'Pause' : 'Play'} size={28} className="text-white" />
    </button>
  );
}
